import { useCallback } from 'react';

import {
  ChangePasswordRequestMutation,
  ChangePasswordRequestMutationVariables,
} from '@generated/ChangePasswordRequestMutation';
import { CHANGE_PASSWORD_REQUEST_MUTATION } from '@graphql/mutations/ChangePasswordRequestMutation';
import { useGraphMutationWithFeedback } from '@hooks/useMutation';

import { UseChangePasswordRequest } from '.';

/**
 * Hook to handle a change password request.
 * @param email - the user's email
 * @returns an object holding a function responsible for requesting a password change and its loading state
 */
export function useChangePasswordRequest(email: string): UseChangePasswordRequest {
  const [mutate, { loading }] = useGraphMutationWithFeedback<
    ChangePasswordRequestMutation,
    ChangePasswordRequestMutationVariables
  >(CHANGE_PASSWORD_REQUEST_MUTATION, { type: 'snackbar' });

  const changePasswordRequest = useCallback(
    () =>
      mutate({
        variables: {
          input: {
            email,
          },
        },
      }),
    [email, mutate]
  );

  return { changePasswordRequest, loading };
}
